import { createContext, useContext, useState } from "react";

interface LoaderContextType {
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
  loadingMessage: string | null;
  setLoadingMessage: (message: string | null) => void;
  clearLoader: () => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider = ({ children }: any) => {
  const [isLoading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState<string | null>(null);

  const clearLoader = () => {
    setLoading(false);
    setLoadingMessage(null);
  }

  return (
    <LoaderContext.Provider
      value={{ isLoading, setLoading, loadingMessage, setLoadingMessage, clearLoader }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
};

export default LoaderContext;